/**
 * roomGhostSynergies.ts - Manual room/ghost conceptual bonuses
 */

import type { GhostId } from './ghosts.js';
import type { RoomTypeId } from './rooms.js';

export interface RoomGhostSynergy {
  roomType: RoomTypeId;
  ghostId: GhostId;
  multiplier: number;
  note: string;
}

export const ROOM_GHOST_SYNERGIES: RoomGhostSynergy[] = [
  { roomType: 'bathroom', ghostId: 'jinaeryeong', multiplier: 1.35, note: 'Classic bathroom ghost scare' },
  { roomType: 'mirror_room', ghostId: 'vampire', multiplier: 1.25, note: 'Mirror twist for vampire reveal' },
  { roomType: 'dungeon', ghostId: 'gangsi', multiplier: 1.3, note: 'Bound movement matches dungeon horror' },
  { roomType: 'graveyard_room', ghostId: 'banshee', multiplier: 1.35, note: 'Lament echo over graves' },
  { roomType: 'lab', ghostId: 'mummy', multiplier: 1.25, note: 'Specimen and experiment horror vibe' },
  { roomType: 'library', ghostId: 'well_spirit', multiplier: 1.2, note: 'Quiet whispering ghost fits library tension' },
  { roomType: 'coffin_room', ghostId: 'blood_count', multiplier: 1.35, note: 'Dracula coffin wake-up moment' },
  { roomType: 'doll_room', ghostId: 'pierrot', multiplier: 1.3, note: 'Uncanny toy and clown pairing' },
  { roomType: 'kitchen', ghostId: 'kappa', multiplier: 1.2, note: 'Odd comic-monster kitchen beat' },
  { roomType: 'dark_corridor', ghostId: 'shadow_stalker', multiplier: 1.25, note: 'Long corridor shadow pressure' },
];

export function getRoomGhostSynergyMultiplier(roomType: RoomTypeId, ghostId: GhostId): number {
  return ROOM_GHOST_SYNERGIES.find((entry) => entry.roomType === roomType && entry.ghostId === ghostId)?.multiplier ?? 1;
}
